import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteAgency } from '../../../../actions';

const AgencyDeleteButton = ({ dispatchDeleteAgency, agencyId }) => {
  const [showModal, setShowModal] = useState(false);

  const onClickDelete = () => dispatchDeleteAgency({ agencyId });

  const onClickShowModal = () => setShowModal(true);

  const onClickCancel = () => setShowModal(false);

  const warningModal = (
    <ConfirmationModal
      show={showModal}
      onClickConfirm={onClickDelete}
      onClickCancel={onClickCancel}
    />
  );

  const deleteButton = (
    <Button color="danger" onClick={onClickShowModal}>
      <i className="fa fa-trash" /> Eliminar
    </Button>
  );

  return (
    <>
      {deleteButton}
      {warningModal}
    </>
  );
};

AgencyDeleteButton.propTypes = {
  agencyId: PropTypes.number.isRequired,
  dispatchDeleteAgency: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchDeleteAgency: deleteAgency,
};

export default connect(null, mapDispatchToProps)(AgencyDeleteButton);
